import { render, staticRenderFns } from "./SendTestForm.vue?vue&type=template&id=5b54bc84"
import script from "./SendTestForm.vue?vue&type=script&lang=js"
export * from "./SendTestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports